<template>
	<div class="float-index">
		<common-layout>
			<div slot="header">
				<h3>浮窗广告</h3>
			</div>
			<div slot="container">
				<div class="float-index.header">
					<el-button type="success" class="float-index.addBtn" @click="openFloatModal('')">+ 新增</el-button>
					<!-- <section>
						<el-input placeholder="请输入" v-model="searchValue" class="input-with-select" clearable @change="search">
							<el-button slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</section> -->
				</div>
				<div class="float-index.table">
					<div class="float-index.box" v-if="tableData.length > 0">
						<div class="float-index.item --text" v-for="(item,index) in tableData" :key="index">
							<article>
								<h2>
									<strong><i class="fa fa-fw fa-star"></i>{{item.isPublish == 2 ? '未发布' : '已发布'}}</strong>
									<p><span @click="openFloatModal(item)">编辑</span><span @click="deleteFloat(item)">删除</span></p>
								</h2>
								<div class="float-index.content --text" >
									<div class="float-index.img --text">
										<img :src="imgUrl + item.content" v-if="item.type == '2'">
										<p v-else>{{item.content}}</p>
									</div>
								</div>
								<div class="float-index.btn --text">
									<i class="fa" :class="item.type == '2' ? 'fa-picture-o': 'fa-file-text-o' "></i>
								</div>
							</article>
						</div>
					</div>
					<div class="float-index.nodata" v-else>暂无数据</div>
					<!-- 分页 -->
					<div class="pagination">
						<div class="grid-content bg-purple-light">
							<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							 :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</common-layout>
		<el-dialog title="浮窗广告" :visible.sync="dialogFormVisible" width="35%">
		  <el-form :model="form" :rules="formRules" ref="floatForm">
			  <el-row>
			    <el-col :span="8">
					<el-form-item label="类型:" :label-width="formLabelWidth">
					    <el-radio-group v-model="form.type" @change="typeWatch">
					      <el-radio-button :label="1">文字</el-radio-button>
						   <el-radio-button :label="2">图片</el-radio-button>
					    </el-radio-group>
					</el-form-item>
				</el-col>
			   </el-row>
			   <el-row v-if="form.type == 1">
				   <el-col :span="12">
					   <el-form-item label="内容:" :label-width="formLabelWidth" prop="content">
						   <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.content"></el-input>
					   </el-form-item>
					 </el-col>
			   </el-row>
			   <el-row v-else>
				   <el-col :span="8">
					   <el-form-item label="海报:" :label-width="formLabelWidth" prop="content">
						   <el-upload class="avatar-uploader" :action="this.uploadURL" :show-file-list="false" :on-success="handleAvatarSuccess">
						   	<img v-if="form.content" :src="imgUrl + form.content" class="avatar" />
						   	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						   </el-upload>
					   </el-form-item>
					 </el-col>
			   </el-row>
			   <el-row>
			     <el-col :span="12">
			   		<el-form-item label="链接:" :label-width="formLabelWidth">
			   			 <el-input  placeholder="请输入跳转链接" v-model="form.link"></el-input>
			   		</el-form-item>
			   	</el-col>
			    </el-row>
		    <el-row>
		      <el-col :span="8">
					<el-form-item label="是否发布:" :label-width="formLabelWidth">
						<el-switch v-model="isPublsh" active-text="是" inactive-text="否" @change="publishWatch">
						</el-switch>
					</el-form-item>
				</el-col>
		     </el-row>
		    
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="createFloat">确 定</el-button>
		  </div>
		</el-dialog>
	</div>

</template>

<script>
	import CommonLayout from '../../components/common-layout.vue'
	export default {
		components: {
			CommonLayout
		},
		data() {
			return {
				operationType:'add',
				searchValue: '',
				total: 20,
				current_page: 1,
				per_page: 10,
				isPublsh:false,
				tableData:[],
				dialogFormVisible:false,
				formLabelWidth:'90px',
				form:{
				  content:'',
				  type:1,
				  isPublish:2,
				  link:''
				},
				formRules:{
					content:[{required:true,trggier:'blur',message:'海报/内容不能为空'}]
				}
			};
		},
		methods: {
			openFloatModal(row) {
                this.operationType = row ? 'edit' : 'add';
				this.dialogFormVisible = true;
				this.resetForm()
				if (row) {
					this.form.content = row.content
					this.form.type = row.type
					this.form.isPublish = row.isPublish
					this.isPublsh = row.isPublish == 1
					this.form.id = row.id
					this.form.link = row.link
				}
			},
			resetForm(){
				this.form.content = ''
				this.form.type = 1
				this.isPublsh = false;
				this.form.isPublish = 2;
				this.form.link = ''
			},
			createFloat(){
				this.$refs['floatForm'].validate(valid => {
					if (valid) {
						if (this.operationType == 'add') {
							delete this.form.id
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/announcement/create`, this.form).then((res) => {
								if (res.code == 0) {
									this.$message.success("新建成功！");
									this.getData('Index_Announcement')
									this.dialogFormVisible = false;
								} else {
									this.$message.error(res.status)
								}
							})
						} else {
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/announcement/update`, this.form).then((res) => {
								if (res.code == 0) {
									this.$message.success("编辑成功！");
									this.getData('Index_Announcement')
									this.dialogFormVisible = false;
								} else {
									this.$message.error(res.status)
								}
							})
				
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			
			handleCurrentChange(e) {
                this.current_page = e;
                this.getData(`Index_Announcement?page=${this.current_page}?content=${this.searchValue}`);
			},
			handleAvatarSuccess(file) {
				this.form.content = file.data.store_result;
			},
			getData(url){
        let params = {};
        if(url.indexOf('?') > -1){
          let urlParams = url.split('?')[1]?.split('&')
          urlParams.forEach(item => {
            params[item.split('=')[0]] = item.split('=')[1]
          })
        }

        this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/announcement/page`, params).then(res => {
				 	if (res.code == 0) {
				 		this.tableData = res.data.data
				 		this.current_page = res.data.current_page
				 		this.total = res.data.total
				 		this.per_page = res.data.per_page
				 	}
				 });
			 },
			 typeWatch(){
				 this.form.content = ''
			 },
			 publishWatch(){
				this.isCanPublish()
			 },
			 isCanPublish(){
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/announcement/page`, {}).then(res => {
					let arr = []
					res.data.data.map(item => {
						if(item.isPublish == 1){
							arr.push(item)
						}
					})
					if(arr.length > 0){
						 if(this.isPublsh){
							 this.$alert('抱歉您已经发表过一篇公告了，不能再次发布，请先取消在发布', '提示', {
							         confirmButtonText: '确定',
							         callback: action => {
							            this.form.isPublish = 2
										this.isPublsh = false
							         }
							  });
						 }else{
							   this.form.isPublish = this.isPublsh ? 1 : 2
						 }
					}else{
						 this.form.isPublish = this.isPublsh ? 1 : 2
					}
				}) 
				
			 },
			 deleteFloat(row){
				 this.$confirm("确定删除文件吗?", "提示", {
				 		confirmButtonText: "确定",
				 		cancelButtonText: "取消",
				 		type: "warning",
				 		center: true
				 	})
				 	.then(() => {
				 		this.http.request(`${urlConfig.devUrl}apij2/admin-api/voucher/announcement/delete?id=` + row.id, "", "delete").then(
				 			response => {
				 				if (response.code == 0) {
				 					this.$message.success("删除成功！");
				 					this.getData("Index_Announcement")
				 				} else {
				 					this.$message.error(response.status)
				 				}
				 			},
				 			error => {}
				 		);
				 	})
				 	.catch(() => {
				 		this.$message({
				 			type: "info",
				 			message: "已取消删除"
				 		});
				 	});
			 }
		},
		created(){
			this.getData('Index_Announcement')
		}
	};
</script>
<style lang="scss">
	@include component(float-index) {
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			margin-right: 30px !important;
			background: #623AA2 !important;
			color: #fff;
			border: none;
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include part(box) {
			display: flex;
			flex-wrap: wrap;
		}
		@include part(nodata){
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
		}

		@include part(item) {
			width: 375px;
			height: 435px;
			margin: 15px 18px;

			article {
				position: relative;
				width: 100%;
				height: 100%;

				>h2 {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					padding: 10px 16px;
					color: #fff;
					font-size: 22.4px;
					line-height: 30px;
					margin: 0;
					z-index: 10;
					transition: all .3s;
					background: #9c27b0;
					display: flex;
					flex-direction: column;
					align-items: flex-start;

					&:before,
					&:after {
						content: ' ';
						position: absolute;
						left: 0;
						top: -16px;
						width: 0;
						border: 8px solid;
						transition: all .3s;

					}

					&:before {
						border-top-color: transparent;
						border-right-color: #4a148c;
						border-bottom-color: #4a148c;
						border-left-color: transparent;
					}

					&:after {
						top: auto;
						bottom: 0;
						border-top-color: transparent;
						border-right-color: transparent;
						border-bottom-color: transparent;
						border-left-color: transparent;
					}

					p {
						margin: 0;
						width: 100%;
						font-size: 14px;
						font-weight: normal;
						text-align: right;

						span {
							display: inline-block;
							margin: 0 10px;
							cursor: pointer;
						}
					}
				}


			}

			@include option(text) {
				h2 {
					top: 0;
					height: 90px;
					background: #673ab7;

					&:before {
						top: 0;
						border-top-color: transparent;
						border-right-color: transparent;
						border-bottom-color: transparent;
						border-left-color: transparent;
					}

					&:after {
						border-top-color: #311b92;
						border-right-color: #311b92;
						border-bottom-color: transparent;
						border-left-color: transparent;
						bottom: -16px;
					}

					p {
						text-align: left;
						margin-top: 5px;
					}
				}

			}
		}

		@include part(content) {
			position: absolute;
			right: 0;
			top: 0;
			bottom: 16px;
			left: 16px;
			transition: all .3s;

			@include option(text) {
				background-color: #ede7f6;
				top: 90px;

			}
		}

		@include part(img) {
			overflow: hidden;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			z-index: 3;
			transition: all .3s;
            
			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
				background: #ede7f6;
				
			}
			p{
				text-align: left;
				padding:20px 15px ;
			}
			@include option(text){
				//top: 20px;
			}

		}

		@include part(btn) {
			position: absolute;
			right: 16px;
			top: 16px;
			border-radius: 50%;

			width: 54px;
			height: 54px;
			line-height: 54px;
			text-align: center;
			color: #fff;
			cursor: pointer;
			z-index: 20;
			transition: all .3s;
			background: #9c27b0;
			font-size: 16px;

			@include option(text) {
				top: 65px;
				border: 5px solid;
				line-height: 44px;
				background: #673ab7;

			}
		}
	  .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	  }
	  .avatar {
		width: 178px;
		height: 178px;
		display: block;
	  }
	}
</style>
